import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheFutureOfAutomation() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section id="the-future-of-automation" ref={sectionRef} className="dark bg-background text-foreground relative min-h-[85vh] flex items-center justify-center overflow-hidden py-20 px-4">
      {}
      <div className="absolute inset-0 z-0 opacity-40 pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-indigo-900/30 blur-[120px] animate-[pulse_8s_ease-in-out_infinite]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-blue-900/30 blur-[120px] animate-[pulse_10s_ease-in-out_infinite_reverse]" />
        <div className="absolute top-[40%] left-[40%] w-[40%] h-[40%] rounded-full bg-violet-900/20 blur-[100px] animate-[pulse_12s_ease-in-out_infinite]" />
      </div>

      {}
      <div className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center">
        {}
        <h1 className={`font-sans font-bold tracking-tighter mb-8 transition-all duration-1000 ease-out transform
            text-5xl sm:text-6xl md:text-7xl lg:text-8xl
            bg-gradient-to-b from-white via-zinc-200 to-zinc-500 bg-clip-text text-transparent
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          THE FUTURE OF
          <br className="hidden md:block" /> AUTOMATION: 2026
        </h1>

        {}
        <p className={`font-sans text-lg md:text-xl text-zinc-400 max-w-2xl mx-auto mb-12 leading-relaxed transition-all duration-1000 delay-300 ease-out transform
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          Discover the next generation of intelligent tools designed to redefine
          efficiency.
          <br className="hidden sm:block" />
          Expertly curated for professionals who demand precision.
        </p>

        {}
        <div className={`transition-all duration-1000 delay-500 ease-out transform
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Button asChild size="lg" className="h-14 px-10 text-lg rounded-full bg-primary text-primary-foreground hover:bg-primary/90 border border-primary/20 shadow-[0_0_30px_-5px_var(--color-primary)] hover:shadow-[0_0_50px_-10px_var(--color-primary)] transition-all duration-300">
            <Link to="/ToolReviewsPage">View the Leaderboard</Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] pointer-events-none z-0" />
    </section>;
}